























import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'

@Component({
  name: 'Accordion',
  components: {
    Icon
  },
  props: {
    title: {
      type: String
    },
    iconPosition: {
      type: String,
      default: 'end'
    },
    icon: {
      type: String,
      default: 'arrow-bottom'
    },
    iconSize: {
      type: Number,
      default: 12
    },
    defaultOpened: {
      type: Boolean,
      default: true
    }
  }
})
export default class Accordion extends Vue {
  opened: boolean = true

  toggle () {
    this.opened = !this.opened
    if (this.opened) {
      this.$emit('open')
    }
    this.$emit('close')
  }

  beforeMount () {
    this.opened = this.$props.defaultOpened
  }
}
